var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';
export default function UserIcon(_a) {
    var { size = 'xsmall' } = _a, rest = __rest(_a, ["size"]);
    return (jsx("svg", Object.assign({ sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, width: sizes[size], height: sizes[size], viewBox: "0 0 20 20" }, rest),
        jsx("defs", null,
            jsx("path", { id: "path-1", d: "M6.5 9a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0-1a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-3.936 3.255l.022-.037c.01-.017.01-.017.13-.135l.12-.064c1.993-.96 5.47-.934 7.39.035a.5.5 0 01.221.222l2.5 5a.5.5 0 01-.894.448L9.63 11.877c-1.644-.745-4.58-.758-6.253-.003l-.27.546a803.32 803.32 0 01-1.768 3.526l-.392.779a.5.5 0 11-.894-.45 2325.141 2325.141 0 002.158-4.3c.124-.248.216-.434.274-.553l.042-.085a.54.54 0 01.037-.082z" })),
        jsx("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            jsx("g", { transform: "translate(3 1)" },
                jsx("mask", { id: "mask-2", fill: "#fff" },
                    jsx("use", { xlinkHref: "#path-1" })),
                jsx("use", { fill: "currentColor", fillRule: "nonzero", xlinkHref: "#path-1" }),
                jsx("g", { fill: "currentColor", mask: "url(#mask-2)" },
                    jsx("path", { d: "M0 0H40V41H0z", transform: "translate(-13 -11)" }))))));
}
//# sourceMappingURL=UserIcon.js.map